// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__14-Qv","col":"CardReaderDesc_col__yq_uD","label":"CardReaderDesc_label__1uGB3"};